import { TableColumnEntity, TableColumnEntityApi } from './entity';

export const normalizeTableColumnEntity = (
  raw: TableColumnEntityApi
): TableColumnEntity => ({
  id: raw.id,
  visible: raw.default_visibility,
  sortable: raw.sortable,
  name: raw.name,
  icons: raw.icons,
});
